import "../styles/privacy.css";

export default function Datenschutz() {
  return (
    <div className="datenschutz-container">
      <h1>RIYU-App</h1>

      <p className="last-updated">
        <strong>Stand:</strong> Februar 2026
      </p>

      <p>
        <em>
          Diese Datenschutzerklärung informiert Dich über Art, Umfang und Zweck
          der Verarbeitung Deiner personenbezogenen Daten durch die RIYU-App. Wir
          nehmen den Schutz Deiner Daten sehr ernst und halten uns strikt an die
          Vorgaben der DSGVO.
        </em>
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>Verantwortliche Stelle im Sinne der DSGVO ist:</p>
      <p>
        ReYou UG (haftungsbeschränkt) i. Gr.
        <br />
        <br />
        Lars Röser / Philipp Brinkmann
        <br />
        <br />
        Mündelheimer Weg 31, 40472 Düsseldorf
        <br />
        <br />
        E-Mail: <a href="mailto:datenschutz@reyou.ai">datenschutz@reyou.ai</a>
      </p>

      <h2>2. Datenschutzbeauftragter</h2>
      <p>Wir haben einen Datenschutzbeauftragten (DSB) bestellt, den Du wie folgt erreichst:</p>
      <p>
        E-Mail: <a href="mailto:dpo@reyou.ai">dpo@reyou.ai</a>
      </p>
      <p>Du kannst Dich jederzeit mit datenschutzrechtlichen Fragen oder Beschwerden direkt an unseren DSB wenden.</p>

      <h2>3. Mindestalter und Nutzungsvoraussetzungen</h2>
      <p>
        Die RIYU-App richtet sich an Personen ab 16 Jahren. Durch die Nutzung der App bestätigst Du, mindestens 16 Jahre alt zu sein. Wir ergreifen angemessene Maßnahmen, um die Nutzung durch Personen unter 16 Jahren zu verhindern. Sollten wir Kenntnis erlangen, dass eine Person unter 16 Jahren Daten übermittelt hat, werden diese unverzüglich gelöscht.
      </p>

      <h2>4. Erhobene Daten und Verarbeitungszwecke</h2>
      <p>
        Wir verarbeiten Deine personenbezogenen Daten nur, soweit dies für die Erbringung unserer Leistungen erforderlich ist oder Du eingewilligt hast. Eine Übersicht der Datenkategorien, Zwecke und Rechtsgrundlagen:
      </p>

      <table className="datenschutz-table">
        <thead>
          <tr>
            <th>Datenkategorie</th>
            <th>Zweck</th>
            <th>Rechtsgrundlage</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Registrierungsdaten
              <br />
              (Name, E-Mail)
            </td>
            <td>Einrichtung und Verwaltung Deines Nutzerkontos</td>
            <td>
              Art. 6 Abs. 1 lit. b DSGVO
              <br />
              (Vertragsanbahnung)
            </td>
          </tr>
          <tr>
            <td>
              Onboarding-Angaben
              <br />
              (Ernährungs-präferenzen, Ziele, Gesundheitsangaben)
            </td>
            <td>Personalisierung der App-Inhalte</td>
            <td>
              Art. 6 Abs. 1 lit. a DSGVO
              <br />
              (Einwilligung)
            </td>
          </tr>
          <tr>
            <td>
              Fotos / Bilder
              <br />
              (können Gesundheitsdaten enthalten)
            </td>
            <td>Bilderkennung zur Rezepterstellung und Lebensmittelanalyse</td>
            <td>
              Art. 6 Abs. 1 lit. a i. V. m.
              <br />
              Art. 9 Abs. 2 lit. a DSGVO
              <br />
              (ausdrückliche Einwilligung)
            </td>
          </tr>
          <tr>
            <td>
              Nutzungsdaten
              <br />
              (Klickpfade, Feature-Nutzung)
            </td>
            <td>Optimierung und Weiterentwicklung der App-Funktionen</td>
            <td>
              Art. 6 Abs. 1 lit. f DSGVO
              <br />
              (Berechtigtes Interesse)
            </td>
          </tr>
          <tr>
            <td>
              Technische Daten
              <br />
              (IP-Adresse, Gerätetyp, OS-Version)
            </td>
            <td>Betrieb, Sicherheit und Fehleranalyse</td>
            <td>
              Art. 6 Abs. 1 lit. f DSGVO
              <br />
              (Berechtigtes Interesse)
            </td>
          </tr>
          <tr>
            <td>
              Kommunikationsdaten
              <br />
              (Nachrichten über Messenger)
            </td>
            <td>Bereitstellung des Kundensupports und der App-Funktionen</td>
            <td>
              Art. 6 Abs. 1 lit. b DSGVO
              <br />
              (Vertragsausführung)
            </td>
          </tr>
        </tbody>
      </table>

      <h2>4.1 Besondere Kategorien personenbezogener Daten (Art. 9 DSGVO)</h2>
      <p>
        Fotos sowie Gesundheits- und Ernährungsangaben (Onboarding) können besondere Kategorien personenbezogener Daten im Sinne von Art. 9 DSGVO darstellen (z.&nbsp;B. Angaben zur Gesundheit, religiöse Präferenzen bei Ernährung). Wir verarbeiten diese Daten ausschließlich auf Grundlage Deiner ausdrücklichen Einwilligung (Art. 9 Abs. 2 lit. a DSGVO), die Du im Rahmen des Onboardings gesondert erteilst. Diese Einwilligung kannst Du jederzeit ohne Angabe von Gründen widerrufen (siehe Abschnitt 9).
      </p>

      <h2>4.2 Profiling und automatisierte Entscheidungsfindung (Art. 22 DSGVO)</h2>
      <p>
        Zur Erstellung personalisierter Ernährungs- und Alltagsempfehlungen führen wir ein Profiling im Sinne von Art. 4 Nr. 4 DSGVO durch. Hierbei werden Deine Onboarding-Angaben, Nutzungsdaten und gegebenenfalls Fotodaten algorithmisch ausgewertet.
      </p>
      <p>
        Es erfolgen keine ausschließlich automatisierten Entscheidungen mit rechtlicher oder ähnlich erheblicher Wirkung im Sinne von Art. 22 DSGVO. Du hast jederzeit das Recht, eine menschliche Überprüfung der generierten Empfehlungen zu verlangen (siehe Abschnitt 9).
      </p>

      <h2>5. Weitergabe an Dritte und Auftragsverarbeiter</h2>
      <p>
        Wir geben Deine Daten nur weiter, soweit dies gesetzlich erlaubt oder von Dir eingewilligt ist. Folgende Kategorien von Empfängern erhalten Zugang zu Deinen Daten:
      </p>

      <h2>5.1 Hosting &amp; Infrastruktur</h2>
      <p>
        Amazon Web Services EMEA SARL, Avenue John F. Kennedy 38, 1855 Luxemburg (»AWS«). Unsere Server befinden sich in der AWS-Region eu-central-1 (Frankfurt, Deutschland). Mit AWS besteht ein Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO. Eine Übermittlung in Drittländer außerhalb der EU findet im Rahmen des Hostings nicht statt.
      </p>

      <h2>5.2 KI-Dienstleister</h2>
      <p>Zur Generierung allgemeine Inhalte setzen wir folgende KI-Dienstleister ein:</p>
      <ul>
        <li>OpenAI, L.L.C., 3180 18th Street, San Francisco, CA 94110, USA</li>
        <li>Anthropic, PBC, 548 Market St., PMB 90375, San Francisco, CA 94104, USA</li>
        <li>Eigene KI-Modelle, betrieben auf AWS-Infrastruktur in Frankfurt</li>
      </ul>
      <p>
        Für OpenAI und Anthropic (Sitz USA) erfolgt die Datenübermittlung in ein Drittland. Rechtsgrundlage sind Standardvertragsklauseln gemäß Art. 46 Abs. 2 lit. c DSGVO. Mit beiden Anbietern bestehen AVV. Wir übermitteln an diese Dienstleister ausschließlich die zur Funktionserbringung notwendigen Daten, keine personenbezogene Profilinformationen.
      </p>

      <h2>5.3 Analyse-Tool: Vercel Web Analytics</h2>
      <p>
        Wir setzen Vercel Web Analytics (Vercel Inc., USA) zur Analyse der Website-Nutzung ein.
      </p>
      <p>
        Rechtsgrundlage: Deine Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO, die Du beim ersten Besuch über unser Consent-Banner erteilst. Ohne Einwilligung wird Vercel Analytics nicht aktiviert.
      </p>
      <p>
        Daten können an Server in den USA übermittelt werden; Rechtsgrundlage sind Standardvertragsklauseln. Du kannst Deine Einwilligung jederzeit über den Link „Cookie-Einstellungen“ widerrufen.
      </p>

      <h2>6. Cookies und ähnliche Technologien</h2>
      <p>
        Wir setzen technisch notwendige Cookies ein (z.&nbsp;B. Session-Cookies zur Aufrechterhaltung Deiner Sitzung). Diese erfordern keine Einwilligung, da sie für den Betrieb der Website unbedingt erforderlich sind (Art. 6 Abs. 1 lit. b DSGVO).
      </p>
      <p>
        Für alle weiteren Analyse-Technologien holen wir Deine Einwilligung über ein Consent-Banner ein, bevor diese aktiviert werden. Du kannst Deine Präferenzen jederzeit über den Link „Cookie-Einstellungen“ ändern.
      </p>

      <h2>7. Speicherdauer</h2>
      <p>
        Wir speichern Deine Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen:
      </p>

      <table className="datenschutz-table">
        <thead>
          <tr>
            <th>Datenkategorie</th>
            <th>Speicherdauer</th>
            <th>Anmerkung</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Registrierungsdaten</td>
            <td>Bis zur Löschung des Accounts, bis zu 30 Tage nach Account-Löschung</td>
            <td>Auf Antrag früher löschbar</td>
          </tr>
          <tr>
            <td>Onboarding- / Profildaten</td>
            <td>Bis zur Account-Löschung, bis zu 12 Monate nach Account-Löschung</td>
            <td>Bei Widerruf der Einwilligung sofort</td>
          </tr>
          <tr>
            <td>Fotos</td>
            <td>Max. 90 Tage nach Upload, dann automatische Löschung</td>
            <td>Keine dauerhafte Speicherung</td>
          </tr>
          <tr>
            <td>Nutzungsdaten</td>
            <td>Max. 12 Monate, dann Anonymisierung</td>
            <td>Anonymisierte Daten fallen nicht mehr unter DSGVO</td>
          </tr>
          <tr>
            <td>Technische Daten (Logs)</td>
            <td>Max. 90 Tage</td>
            <td>Für Sicherheit und Fehleranalyse</td>
          </tr>
          <tr>
            <td>Kommunikation (Messenger)</td>
            <td>Gemäß AGB/Policy der jeweiligen Plattform</td>
            <td>Nicht in unserer Kontrolle</td>
          </tr>
        </tbody>
      </table>

      <p>
        Nach Ablauf dieser Fristen werden Deine Daten automatisch gelöscht oder irreversibel anonymisiert. Bei wesentlichen Änderungen der Speicherdauern wirst Du mindestens 4 Wochen vorab per E-Mail informiert.
      </p>

      <h2>8. Deine Rechte als betroffene Person</h2>
      <p>Du hast gegenüber uns folgende Rechte bezüglich Deiner personenbezogenen Daten:</p>
      <ul>
        <li>Recht auf Auskunft über Deine gespeicherten Daten (Art. 15 DSGVO)</li>
        <li>Recht auf Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
        <li>Recht auf Löschung (»Recht auf Vergessenwerden«, Art. 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO), insbesondere gegen Profiling</li>
        <li>Recht auf Widerruf Deiner Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
        <li>Recht auf menschliche Überprüfung KI-generierter Empfehlungen (Art. 86 EU AI Act i.&nbsp;V.&nbsp;m. unserer Verpflichtung nach § 10 AGB)</li>
      </ul>
      <p>
        Um Deine Rechte auszuüben, wende Dich an: <a href="mailto:datenschutz@reyou.ai">datenschutz@reyou.ai</a>. Wir bearbeiten Deine Anfrage unverzüglich, spätestens innerhalb eines Monats (Art. 12 Abs. 3 DSGVO).
      </p>

      <h2>8.1 Beschwerderecht bei der Aufsichtsbehörde</h2>
      <p>
        Du hast das Recht, Dich bei der zuständigen Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO). Zuständig für ReYou ist:
      </p>
      <p>
        Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)
        <br />
        <br />
        Postfach 20 04 44, 40102 Düsseldorf
        <br />
        <br />
        Telefon: 0211 38424-0
        <br />
        <br />
        E-Mail: <a href="mailto:poststelle@ldi.nrw.de">poststelle@ldi.nrw.de</a>
        <br />
        <br />
        Website: ldi.nrw.de
      </p>

      <h2>9. Einwilligung und Widerruf</h2>
      <p>
        Soweit wir Deine Daten auf Basis einer Einwilligung verarbeiten (Art. 6 Abs. 1 lit. a bzw. Art. 9 Abs. 2 lit. a DSGVO), hast Du das Recht, diese Einwilligung jederzeit ohne Angabe von Gründen zu widerrufen. Der Widerruf hat keine rückwirkende Wirkung auf bereits erfolgte Verarbeitungen.
      </p>
      <p>Einwilligungen kannst Du widerrufen:</p>
      <ul>
        <li>direkt über den Link „Cookie-Einstellungen“ auf der Website</li>
        <li>per E-Mail an <a href="mailto:datenschutz@reyou.ai">datenschutz@reyou.ai</a></li>
      </ul>
      <p>
        Nach Widerruf werden die betroffenen Daten unverzüglich gelöscht, soweit keine andere Rechtsgrundlage für die Verarbeitung besteht.
      </p>

      <h2>10. Datensicherheit</h2>
      <p>
        Wir setzen technische und organisatorische Maßnahmen (TOMs) ein, um Deine Daten gegen unbefugten Zugriff, Verlust oder Missbrauch zu schützen. Dazu gehören insbesondere:
      </p>
      <ul>
        <li>Verschlüsselung aller Datenübertragungen via TLS/HTTPS</li>
        <li>Verschlüsselung gespeicherter Daten (Encryption at Rest auf AWS)</li>
        <li>Zugriffsbeschränkungen nach dem Prinzip der minimalen Rechte (Need-to-know)</li>
        <li>Regelmäßige Sicherheitsüberprüfungen der eingesetzten Systeme</li>
      </ul>

      <h2>11. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir passen diese Datenschutzerklärung an, wenn sich rechtliche Anforderungen oder unsere Datenverarbeitungspraktiken ändern.
      </p>
      <p>
        Bei wesentlichen Änderungen – insbesondere bei neuen Verarbeitungszwecken oder neuen Kategorien von Empfängern – informieren wir Dich mindestens 4 Wochen vorab per E-Mail und holen, sofern erforderlich, eine erneute Einwilligung ein.
      </p>
      <p>
        Das Datum der letzten Aktualisierung ist oben auf dieser Seite vermerkt. Ältere Versionen stellen wir auf Anfrage zur Verfügung.
      </p>

      <h2>12. Kontakt</h2>
      <p>Bei Fragen zum Datenschutz oder zur Ausübung Deiner Rechte erreichst Du uns hier:</p>
      <p>
        <a href="mailto:datenschutz@reyou.ai">datenschutz@reyou.ai</a>
        <br />
        <br />
        ReYou UG (haftungsbeschränkt) i. Gr., Mündelheimer Weg 31, 40472 Düsseldorf
        <br />
        <br />
        Datenschutzbeauftragter: <a href="mailto:dpo@reyou.ai">dpo@reyou.ai</a>
      </p>
    </div>
  );
}
